import { useSelector } from "react-redux";
import ProgressBar from "~/components/ProgressBar/ProgressBar.jsx";
import { FaArrowRightLong } from "react-icons/fa6";

import "./StickyAddToCart.css";

const StickyAddToCart = ({ data, deliveryCommitmentData, handleAddToCart, selectedCapsules }) => {
  const machine = useSelector((state) => state.machine.machine);

  const frequency = useSelector((state) => state.frequency.frequency);

  const selectedMachineVariantId = useSelector((state) => state.machine.selectedMachineVariantId);

  console.log("machine:", machine);
  console.log("selectedMachineVariantId:", selectedMachineVariantId);
  console.log("frequency:", frequency);
  console.log("selectedCapsules:", selectedCapsules);

  return (
    <>
      {selectedCapsules.length > 0 && (
        <div className="sticky-add-to-cart-wrapper">
          <div className="sticky-add-to-cart">
            <ProgressBar selectedCapsules={selectedCapsules} data={data} />
            <button
              onClick={() => handleAddToCart(data, deliveryCommitmentData)}
              className="add-to-cart-button">
              ADD TO CART <FaArrowRightLong />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default StickyAddToCart;
